// ** React Imports
import { useEffect, useRef, useState } from 'react'

import { client } from 'src/utils/axios-client';
import { LeadScreenStore, LeadActivity, Lead, NextActivity, LeadAccountStore, ViewType, ActivityDialogStore, LeadCompanyStore, CompanyDialogStore, LeadSprintStore, SprintDialogStore, LeadActivityHistoryStore, ActivityHistoryDialogStore, LeadActivityCadenceStore, CadenceListDialogStore, LeadActivityOutcomeStore, ActivityOutcomes, ActivityNotesDialogStore } from 'src/stores/LeadStore';
import { getActivityEndpoint, leadEndpoints } from '../../../configs/endpoints';

// ** MUI Imports
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import Tooltip from '@mui/material/Tooltip'
import Grid from '@mui/material/Grid'
import Link from '@mui/material/Link';
import _ from 'lodash';
import Badge, { BadgeProps } from '@mui/material/Badge';
import Button from '@mui/material/Button';
import Icon from 'src/features/common/CustomIcon';
import MenuItem from '@mui/material/MenuItem';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import ListItemIcon from '@mui/material/ListItemIcon';
import InputLabel from '@mui/material/InputLabel';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import { ProblemDetails } from '../../../types/ApiErrorResponse';
import SaveTwoToneIcon from '@mui/icons-material/SaveTwoTone';
import FormControl from '@mui/material/FormControl';
import LocalPhoneTwoToneIcon from '@mui/icons-material/LocalPhoneTwoTone';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import DoActivityOutcomes from './DoActivityOutcomes';
import PhoneInTalkTwoToneIcon from '@mui/icons-material/PhoneInTalkTwoTone';
import CheckCircleOutlineTwoToneIcon from '@mui/icons-material/CheckCircleOutlineTwoTone';
import StandardSkeleton from '../../common/StandardSkeleton';

const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
    '& .MuiBadge-badge': {
        right: 33,
        top: 10,
        border: `2px solid ${theme.palette.background.paper}`,
        padding: '0 4px',
    },
}));


const ActivityNotes = () => {
    const outcomesRecord = LeadActivityOutcomeStore.useState(s => s.record);
    const selectedLead = LeadScreenStore.useState(s => s.selectedLead);
    
    const handleTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        LeadActivityOutcomeStore.update(s => { s.record.activityNotes = event.target.value })
    };

    const submitNotes = () => {
        ActivityNotesDialogStore.update(s => { s.activityNotesDialogMode = false })
    };

    if (outcomesRecord) {
        return (
            <Box>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Card>
                            <CardContent>
                                <Box >
                                    <Grid container alignContent='left' spacing={2}>
                                        <Grid item xs={12} md={10} alignContent='left' justifyContent={'left'} sx={{ pt: 1, display: 'flex', alignItems: 'left', flexDirection: 'column' }}>
                                            <TextField
                                                id="activityNotes"
                                                label="Activity Notes"
                                                multiline
                                                rows={6}
                                                placeholder="Enter activity notes here..."
                                                onChange={handleTextChange}
                                                fullWidth
                                                value={outcomesRecord.activityNotes}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={2} alignItems="flex-start" sx={{ pt: 1, display: 'flex', flexDirection: 'row' }}>
                                            <Tooltip title="Done" >
                                                <Button size='small' variant="outlined" color="info" startIcon={<CheckCircleOutlineTwoToneIcon />} sx={{ mr: 3 }} onClick={submitNotes}>
                                                    Done
                                                </Button>
                                            </Tooltip>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        )
    }
    else {
        return <StandardSkeleton />
    }

}

export { ActivityNotes }

export default ActivityNotes;